<template>
	<div class="self-start mb-20">
		<div id="back">
			<router-link to="/">
				<i class="times"></i>
			</router-link>
		</div>

		<div class="work-tiles container">
			<div class="flex flex-wrap -mx-3">
				<div class="w-full md:w-1/2 px-3 mb-6">
					<router-link to="/work/dashboard-redesign">
						<img class="box-shadow border-radius-8" src="/img/dashboard-redesign-min.png" srcset="/img/dashboard-redesign@2x-min.png 2x" alt="Dashboard Redesign" />
					</router-link>
				</div>

				<div class="w-full md:w-1/2 px-3 mb-6">
					<router-link to="/work/ios-android-app">
						<img class="box-shadow border-radius-8" src="/img/ios-android-min.png" srcset="/img/ios-android@2x-min.png 2x" alt="iOS & Android App" />
					</router-link>
				</div>
			</div>

			<div class="flex flex-wrap -mx-3">
				<div class="w-full md:w-1/2 px-3 mb-6">
					<router-link to="/work/ellie-mae-blocks">
						<img class="box-shadow border-radius-8" src="/img/ellie-mae-blocks-min.png" srcset="/img/ellie-mae-blocks@2x-min.png 2x" alt="Ellie Mae Blocks" />
					</router-link>
				</div>

				<div class="w-full md:w-1/2 px-3 mb-6">
					<router-link to="/work/websites">
						<img class="box-shadow border-radius-8" src="/img/websites-min.png" srcset="/img/websites@2x-min.png 2x" alt="Websites" />
					</router-link>
				</div>
			</div>

			<div class="flex flex-wrap -mx-3">
				<div class="w-full md:w-1/2 px-3 mb-6">
					<router-link to="/work/corporate-identity">
						<img class="box-shadow border-radius-8" src="/img/corporate-identity-min.png" srcset="/img/corporate-identity@2x-min.png 2x" alt="Corporate Identity" />
					</router-link>
				</div>
				<div class="w-1/2">&nbsp;</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
	name: 'projects',
	data() {
		return {
			newProject: {
				name: 'a',
				build: 'b'
			}
		}
	},
	computed: {
		...mapState([
			'projects'
		]),
		...mapGetters([
			'getProjectCount'
		])
	},
	components: {

	},
	methods: {
		...mapMutations([
			'APP_CLASS'
		])
		// ...mapMutations([
		// 	'ADD_PROJECT'
		// ]),
		// addProject: function() {
		// 	this.ADD_PROJECT(this.newProject);
		// },



		// ...mapActions([
		// 	'removeProject'
		// ]),
		// rmProject: function(payload) {
		// 	this.removeProject(payload);
		// }
	},
	created: function() {
		this.APP_CLASS('page-work hungry');
	}
}
</script>